<!-- Sección 1 - Análisis de Riesgo -->
<section id="section-1" class="row bg-image d-flex justify-content-center align-items-center section1">
  <div class="container">
    <div class="row justify-content-start align-items-center" data-aos="fade-right" data-aos-duration="3000">
      <div class="col-lg-6 col-md-8 col-sm-12 text-white fw-bold px-4" style="margin-left: 2%;">
        <h2 class="section1-title">
          Análisis de Riesgo Financiero y Comercial al alcance de un click
        </h2>
        <p class="section1-text">
          Evalúa a tus clientes y proveedores con herramientas similares a las que utilizan las principales instituciones financieras.
        </p>
        <p class="section1-text">
          Evalúa tu empresa - Conoce cómo te analizan y ven tus acreedores.
        </p>
      </div>
    </div>
    <div class="row justify-content-center align-items-center mt-4 d-none" data-aos="fade-down" data-aos-duration="1000">
      <button class="btn btn-cotiza2 mt-5" data-bs-toggle="modal" data-bs-target="#contactModal">
        Contáctanos
      </button>
    </div>
  </div>
</section>

<section id="section-2" class="section2 container">
  <div class="row text-center mb-5">
    <div class="col">
      <h2 class="section2-title">Cómo funciona</h2>
    </div>
  </div>
  <div class="step-container">
    <div class="row step-row d-flex justify-content-center">
      <div class="col-lg-3 col-md-6 col-sm-12 text-center step-box">
        <div class="step-circle active" id="step1"></div>
        <div class="step-content">
          <h2>Accede a la plataforma</h2>
          <p>Ingresa tus credenciales de acceso, las cuales solo tú administras y controlas.</p>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12 text-center step-box">
        <div class="step-circle" id="step2"></div>
        <div class="step-content">
          <h2>Identifica y Tipifica al Sujeto de Análisis</h2>
          <p>Ingresa los antecedentes mínimos requeridos para identificar al sujeto y el sector de actividad en que participa y su tamaño relativo.</p>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12 text-center step-box">
        <div class="step-circle" id="step3"></div>
        <div class="step-content">
          <h2>Ingresa los antecedentes del sujeto</h2>
          <p>Ingresa en forma simple los Estados Financieros o carga la Carpeta tributaria del sujeto de análisis.</p>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12 text-center step-box">
        <div class="step-circle2" id="step4"></div>
        <div class="step-content">
          <h2>Reportes completos del nivel de crédito a un click</h2>
          <p>Incluye análisis financiero de riesgo de crédito y score de riesgo del sujeto, además de su capacidad económica y sus principales indicadores.</p>
        </div>
      </div>
    </div>
  </div>
</section>


<div class="row justify-content-center">
  <div class="section-5 d-flex justify-content-center align-items-center text-center w-100">
    <div class="row justify-content-center align-items-center w-100">
      <div class="col-12">
        <h1 class="text-center text-white" style="font-size: 2rem; line-height: 1.4;">
          Evalúa a tus clientes y proveedores con herramientas similares a las que utilizan las principales instituciones financieras.
        </h1>
        <div style="height: 30px;"></div>
        <p class="text-center text-white" style="font-size: 1.5rem; line-height: 1.4;">
          Evalúa tu empresa - Conoce como te analizan y ven tus acreedores.
        </p>
      </div>
    </div>
  </div>
</div>

<div class="feature-container py-5">
  <div class="feature-row">
    <div class="feature-item">
      <div class="feature-content">
        <div class="feature-icon"><i class="ion--documents-sharp"></i></div>
        <h3 class="feature-title">Precisión</h3>
        <p class="feature-text">
          Accede a reportes con análisis detallados y precisos de riesgo financiero y comercial.
        </p>
      </div>
    </div>
    <div class="feature-item">
      <div class="feature-content">
        <div class="feature-icon"><i class="octicon--graph-16"></i></div>
        <h3 class="feature-title">Facilidad</h3>
        <p class="feature-text">
          Interfaz sencilla que te permite obtener resultados de forma rápida y sin complicaciones.
        </p>
      </div>
    </div>
    <div class="feature-item">
      <div class="feature-content">
        <div class="feature-icon"><i class="carbon--security"></i></div>
        <h3 class="feature-title">Seguridad</h3>
        <p class="feature-text">
          Cumplimos con las regulaciones de privacidad de datos y seguridad en línea de acuerdo a la ley 19.628.
        </p>
      </div>
    </div>
    <div class="feature-item">
      <div class="feature-content">
        <div class="feature-icon"><i class="material-symbols--shopping-bag-speed"></i></div>
        <h3 class="feature-title">Rapidez</h3>
        <p class="feature-text">
          Genera reportes completos en solo unos minutos para tomar decisiones informadas rápidamente.
        </p>
      </div>
    </div>
    <div class="feature-item">
      <div class="feature-content">
        <div class="feature-icon"><i class="medical-icon--i-administration"></i></div>
        <h3 class="feature-title">Gestión</h3>
        <p class="feature-text">
          Gestiona tus propios usuarios, la cantidad de reportes generados y más, con total autonomía y facilidad.
        </p>
      </div>
    </div>
    <div class="feature-item">
      <div class="feature-content">
        <div class="feature-icon"><i class="streamline--strategy-tasks-solid"></i></div>
        <h3 class="feature-title">Enfoque Estratégico</h3>
        <p class="feature-text">
          Establece el nivel de riesgo financiero por segmento de tu cartera de clientes y proveedores a fin de establecer una política de provisiones por cartera riesgosa.
        </p>
      </div>
    </div>
  </div>
</div>

<div id="nosotros" class="container-fluid position-relative">
  <img src="/assets/nosotrosBack.png" alt="Nosotros" class="img-fluid w-100 h-100 background-image">
  <div class="position-absolute top-50 start-50 translate-middle text-center">
    <h2 class="text-white fw-bold mb-4">Quiénes Somos</h2>
    <button 
      class="btn-custom" 
      data-bs-toggle="modal" 
      data-bs-target="#nosotrosModal"
    >
      <img src="/assets/Logo Finsinfo.svg" alt="Logo SAFyC">
      <span class="fw-regular">FINSINFO |</span>
      <span class="fw-extralight">Financiero</span>
    </button>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="nosotrosModal" tabindex="-1" aria-labelledby="nosotrosModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body text-center">
        <h4>SERTRIAD FINANCIERO SPA</h4>
        <p>
          SERTRIAD FINANCIERO SPA, empresa con amplia experiencia en asesoría financiera, pone a disposición de las empresas 
          <strong>FINSINFO</strong>, un sistema especializado de evaluación financiera y comercial. Basado en modelos matemáticos e Inteligencia Artificial, 
          FINSINFO permite medir la solvencia de los evaluados y determinar la probabilidad real de recuperación de créditos.
        </p>
        <p>
          El objetivo principal es la <strong>prevención de riesgos</strong>, asegurando un retorno óptimo del patrimonio invertido. 
          Con un enfoque técnico y preciso, FINSINFO se convierte en una herramienta clave para fortalecer la gestión comercial, operacional y crediticia.
        </p>
        <p class="fw-bold">Evalúa, analiza y crece con nosotros.</p>
        <button class="col-10 btn-close-modal" data-bs-dismiss="modal">Cerrar</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade modalContactanos" id="contactModal" tabindex="-1" aria-labelledby="contactModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
   <!-- Botón de cierre dentro del modal -->
      <button type="button" class="btn-close btn-custom-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>

      <div class="row modal-body d-flex justify-content-center align-items-center">
        <div class="col-md-6 col-som d-flex flex-column justify-content-center text-center">
          <h2>Somos tu éxito financiero</h2>
          <p>
            Completa el formulario a continuación y nos pondremos en contacto contigo en breve.
            ¡Contáctanos hoy y descubre cómo podemos ayudarte a alcanzar tus metas financieras!
          </p>
          <div class="text-center mt-3">
            <img src="/assets/Logo Finsinfo.svg" alt="Logo" width="200" height="200" class="d-inline-block align-text-top" />
          </div>
        </div>
        <div class="col-md-6 col-Contacto d-flex justify-content-center align-items-center shadow">
          <form class="w-100">
            <div class="mb-3 input-group">
              <span class="input-group-text">
                <i class="bi bi-person-fill"></i>
              </span>
              <input type="text" class="form-control" id="name" placeholder="Nombre*" required />
            </div>
            <div class="mb-3 input-group">
              <span class="input-group-text">
                <i class="bi bi-phone-fill"></i>
              </span>
              <input type="tel" class="form-control" id="phone" placeholder="Teléfono*" required />
            </div>
            <div class="mb-3 input-group">
              <span class="input-group-text">
                <i class="bi bi-envelope-fill"></i>
              </span>
              <input type="email" class="form-control" id="email" placeholder="Correo*" required />
            </div>
            <div class="mb-3 input-group">
              <span class="input-group-text">
                <i class="bi bi-building-fill"></i>
              </span>
              <input type="text" class="form-control" id="empresa" placeholder="Nombre de la empresa (opcional)" />
            </div>
            <div class="d-flex justify-content-center">
              <button type="submit" class="btn btn-enviar">Enviar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>



<div class="row justify-content-center">
  <div class="section-5 d-flex justify-content-center align-items-center text-center w-100">
    <div class="row justify-content-center align-items-center w-100">
      <div class="col-12">
        <h1 class="text-center text-white" style="font-size: 40px">
          Conoce como te ven y evalúan tus acreedores
        </h1>
      </div>
    </div>
  </div>
</div>

<div id="section-4" class="section-4 position-relative text-center d-flex flex-column justify-content-center align-items-center">
  <h2 
    data-aos="fade-up"
    data-aos-duration="1000"
    class="text-white fw-bold mb-4 section-4-title"
  >
    ¡¿Qué estás esperando?!
  </h2>
  <button
    type="button"
    class="contactanos-btn"
    data-bs-toggle="modal"
    data-bs-target="#contactModal"
    data-aos="fade-up"
    data-aos-duration="1000"
  >
    Contáctanos
  </button>
</div>
